import * as React from 'react';
import { LocalizeContextProps, withLocalize, Translate } from 'react-localize-redux';
import bindAllOfThis from 'src/utils/BindThisHelper'; // 'this' binder
import { Input, Modal, Upload, Button, Icon } from 'antd';
import { UploadFile, UploadProps } from "antd/lib/upload/interface";
import StudentStatementDTO from "src/models/statement/StudentStatementDTO";
import UserCompletionDTO from "src/models/statement/UserCompletionDTO";

interface ViewStatementModalProps extends LocalizeContextProps {
    statement: StudentStatementDTO;
    visible: boolean;
    onClose: () => void;
}

interface ViewStatementModalState {
}

class ViewStatementModal extends React.Component<ViewStatementModalProps, ViewStatementModalState> {
    constructor(props: ViewStatementModalProps) {
        super(props);
        bindAllOfThis(this, ViewStatementModal.prototype);

        this.state = {
        };
    }

    private onClose() {
        this.props.onClose && this.props.onClose();
    }

    render() {
        if (this.props.statement == null) {
            return null;
        }

        let userCompletion = this.props.statement.userCompletion || {} as UserCompletionDTO;
        let statementFiles = userCompletion.statementFiles || [];
        let fileList = statementFiles.map<UploadFile>(x => {
            let newFile: UploadFile = undefined;
            if (x != null) {
                newFile = {
                    uid: x.id.toString(),
                    name: x.fileName,
                    status: 'done',
                    thumbUrl: x.azureFileUrl,
                } as UploadFile;
            }
            return newFile;
        });

        let uploadProps: UploadProps = {
            action: "",
            // onChange: this.handleFileChange,
            beforeUpload: (file) => {
                // Stop the actual file upload process, we will do that later
                return false;
            },
            fileList: fileList,
            listType: "picture",
            multiple: true
        };

        return <Modal
            maskClosable={false}
            visible={this.props.visible}
            onCancel={this.onClose}
            footer={[
                <Button key="done" onClick={this.onClose}><Translate id="common.done" /></Button>,
            ]}
        >
            <div>
                <h3>{this.props.statement.statementText}</h3>

                <label>{this.props.translate("public.studentStatements.notesHeader")}:</label>
                <Input.TextArea
                    key="studentNotes"
                    rows={3}
                    autoComplete="off"
                    value={userCompletion.statementNotes}>
                </Input.TextArea>

                <Upload {...uploadProps} />
            </div>
        </Modal>;
    }
}

export default withLocalize(ViewStatementModal);



// WEBPACK FOOTER //
// ./src/components/admin/ViewStatementModal.tsx